import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { TopNavigation } from "../../htmlComponents/TopNavigation";
import { useUserContext } from "../../_context/UserContext";
import CNALOGO from "../../_resources/Images/logo.png";
import "./AdminLayout.css";

export const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { currentPage } = useUserContext();

  return (
    <>
      {/* Mobile top bar */}
      <div className="admin-mobile-topbar">
        <img src={CNALOGO} alt="CNA Logo" className="admin-mobile-logo" />
        <button
          className="admin-hamburger"
          onClick={() => setSidebarOpen(true)}
          aria-label="Open menu"
        >
          <span /><span /><span />
        </button>
      </div>

      <div className="admin-shell">
        <div
          className={`admin-sidebar-overlay${sidebarOpen ? " open" : ""}`}
          onClick={() => setSidebarOpen(false)}
        />

        <aside className={`admin-sidebar${sidebarOpen ? " open" : ""}`}>
          <TopNavigation onClose={() => setSidebarOpen(false)} />
        </aside>

        <main className="admin-content">
          {/* Page header: breadcrumb + title */}
          <div className="admin-topbar">
            <div className="admin-topbar-left">
              {currentPage && (
                <h1 className="admin-page-title">{currentPage}</h1>
              )}
            </div>
          </div>

          <div className="admin-content-body">
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
};
